import React, { useState } from 'react';
import './DropDownWithButton.scss';
import NewTemplate from '../../../assets/icons/newTemplate.png';
import Template from '../../../assets/icons/template.png';
import Select, { components } from 'react-select';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/arrowdown.svg';
import AddCircleIcon from '../../../assets/icons/add_circle.svg';
import DocumentIcon from '../../../assets/icons/documenttext.svg';

import { SingleValue, ActionMeta, InputActionMeta } from 'react-select';

interface IDropDownWithButtonProps {
    label?: string;
    options: string[];
    placeHolder?: string;
    buttonText: string;
    buttonAction: () => void;
}

interface ITemplate {
    image: string;
    salaryInfo: string;
    name: string;
    holidayAllowance?: string;
    incomeReport: string;
}

interface IOptionType {
    value: string;
    label: string;
    image: string;
}
const Option = (props: any) => (
    <components.Option {...props}>
        <img
            src={props.data.image}
            alt={props.data.label}
            style={{ marginRight: '10px', height: '20px', position: 'relative', top: '5px' }}
        />
        {props.data.label}
    </components.Option>
);

const colorStyles = {
    control: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => ({
        ...styles,
        backgroundColor: 'none',
        border: 'none',
        width: '100%!important',
    }),
    multiValueRemove: (base: any) => ({ ...base, display: 'none' }),
};

const DropDownWithButton = ({ label, options, placeHolder, buttonText, buttonAction }: IDropDownWithButtonProps) => {
    const choices: ITemplate[] = [
        {
            image: AddCircleIcon,
            salaryInfo: '9,16원 ',
            name: '템플릿명',
            holidayAllowance: '주휴수당 자동 가산 / 휴계시간 자동 차감 / 추가야간휴일 수당 50% 자동 가산  ',
            incomeReport: '4대보험 (국민연금, 건강보험,고용보험, 산재보험)',
        },
        {
            image: DocumentIcon,
            salaryInfo: '9,160원 ',
            name: '직접입력',
            holidayAllowance: '주휴수당 자동 가산 / 휴계시간 자동 차감 / 추가야간휴일 수당 50% 자동 가산 ',
            incomeReport: '4대보험 (국민연금, 건강보험,고용보험, 산재보험)',
        },
    ];

    const [data, setData] = useState<ITemplate>({
        image: '',
        salaryInfo: '',
        name: '',
        holidayAllowance: '',
        incomeReport: '',
    });

    return (
        <div className="dropDownWithButtonComponent">
            <div className="inputLabel"> {label}</div>
            <div className="dropDownWrapper">
                <div className="inputWrapper">
                    <div style={{ width: '100%' }}>
                        <Select
                            options={choices.map((choice) => ({
                                value: choice.name,
                                label: choice.name,
                                image: choice.image,
                            }))}
                            onChange={(e: any) => setData(choices.filter((choice) => choice.name == e.value)[0])}
                            styles={colorStyles}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: () => (
                                    <div style={{ paddingRight: '15px', paddingTop: '5px' }}>
                                        <ArrowDownIcon />
                                    </div>
                                ),
                                Option,
                            }}
                        />
                    </div>
                </div>
                <button
                    onClick={() => {
                        buttonAction();
                    }}
                >
                    {buttonText}
                </button>
            </div>
            <div className="selectionDetails" hidden={data.image === ''}>
                <div className="row">
                    <div className="rowLabel">급여정보</div>
                    <div className="rowValue">
                        <div className="indicator">시급</div>
                        {data.salaryInfo}
                    </div>
                </div>
                <div className="row">
                    <div className="rowLabel">주휴수당</div>
                    <div className="rowValue">{data.holidayAllowance}</div>
                </div>
                <div className="row">
                    <div className="rowLabel">소득신고</div>
                    <div className="rowValue">{data.incomeReport}</div>
                </div>
            </div>

            <div className="buttonRow">
                <button className="cancel">취소</button>
                <button className={`${data.image ? 'success' : 'disabled'}`}>적용</button>
            </div>
        </div>
    );
};

export default DropDownWithButton;
